/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    pre: "pre",
    code: "code",
    a: "a",
    blockquote: "blockquote"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "安装(Installation)"
    }), "\n", _jsx(_components.p, {
      children: "¥Installation"
    }), "\n", _jsx(_components.p, {
      children: "安装 styled-components 只需一个命令，你就可以开始使用了："
    }), "\n", _jsx(_components.p, {
      children: "¥Installing styled-components only takes a single command and you're ready to roll:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        children: "# with npm\nnpm install styled-components\n\n# with yarn\nyarn add styled-components\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["如果你使用像 ", _jsx(_components.a, {
        href: "https://yarn.nodejs.cn/",
        children: "yarn"
      }), " 这样支持 ", _jsx(_components.a, {
        href: "https://yarn.nodejs.cn/lang/en/docs/selective-version-resolutions/",
        children: "\"resolutions\""
      }), " package.json 字段的包管理器，我们还强烈建议你向其中添加一个与主要版本范围相对应的条目。这有助于避免因项目中安装多个版本的样式组件而引起的一系列问题。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥If you use a package manager like ", _jsx(_components.a, {
        href: "https://yarn.nodejs.cn/",
        children: "yarn"
      }), " that supports the ", _jsx(_components.a, {
        href: "https://yarn.nodejs.cn/lang/en/docs/selective-version-resolutions/",
        children: "\"resolutions\""
      }), " package.json field, we also highly recommend you add an entry to it as well corresponding to the major version range. This helps avoid an entire class of problems that arise from multiple versions of styled-components being installed in your project."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "package.json"
      }), " 年："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥In ", _jsx(_components.code, {
        children: "package.json"
      }), ":"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-json",
        children: "{\n  \"resolutions\": {\n    \"styled-components\": \"^5\"\n  }\n}\n"
      })
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsxs(_components.p, {
        children: ["强烈建议（但不是必需）也使用 ", _jsx(_components.a, {
          href: "/docs/tooling#babel-plugin",
          children: "Babel 插件"
        }), "。它提供了许多好处，例如更清晰的类名、服务器端渲染兼容性、更小的包等等。"]
      }), "\n", _jsxs(_components.p, {
        children: ["¥It's highly recommended (but not required) to also use the ", _jsx(_components.a, {
          href: "/docs/tooling#babel-plugin",
          children: "Babel plugin"
        }), ". It offers many benefits like more legible class names, server-side rendering compatibility, smaller bundles, and more."]
      }), "\n"]
    }), "\n", _jsxs("details", {
      children: [_jsx("summary", {
        children: "Click here to see alternative CDN installation instructions"
      }), _jsxs(_components.p, {
        children: ["如果你不使用模块打包器或包管理器，我们还有一个托管在 ", _jsx(_components.a, {
          href: "http://unpkg.com",
          children: "unpkg"
        }), " CDN 上的全局 (\"UMD\") 构建。只需将以下 ", _jsx(_components.code, {
          children: "<script>"
        }), " 标记添加到 HTML 文件的底部："]
      }), _jsxs(_components.p, {
        children: ["¥If you're not using a module bundler or package manager we also have a global (\"UMD\") build hosted on the ", _jsx(_components.a, {
          href: "http://unpkg.com",
          children: "unpkg"
        }), " CDN. Simply add the following ", _jsx(_components.code, {
          children: "<script>"
        }), " tag to the bottom of your HTML file:"]
      }), _jsx(_components.pre, {
        children: _jsx(_components.code, {
          className: "language-html",
          children: "<script src=\"https://unpkg.com/styled-components/dist/styled-components.min.js\"></script>\n"
        })
      }), _jsxs(_components.p, {
        children: ["添加 ", _jsx(_components.code, {
          children: "styled-components"
        }), " 后，你将可以访问全局 ", _jsx(_components.code, {
          children: "window.styled"
        }), " 变量。"]
      }), _jsxs(_components.p, {
        children: ["¥Once you've added ", _jsx(_components.code, {
          children: "styled-components"
        }), " you will have access to the global ", _jsx(_components.code, {
          children: "window.styled"
        }), " variable."]
      }), _jsx(_components.pre, {
        children: _jsx(_components.code, {
          className: "language-tsx",
          children: "const Component = window.styled.div`\n  color: red;\n`\n"
        })
      }), _jsxs(_components.blockquote, {
        children: ["\n", _jsxs(_components.p, {
          children: ["这种使用风格要求 ", _jsx(_components.a, {
            href: "https://react.nodejs.cn/docs/cdn-links.html",
            children: "react CDN 打包"
          }), " 和 ", _jsxs(_components.a, {
            href: "https://unpkg.com/react-is/umd/react-is.production.min.js",
            children: [_jsx(_components.code, {
              children: "react-is"
            }), " CDN 打包包"]
          }), " 也位于页面上（在 styled-components 脚本之前）。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥This style of usage requires the ", _jsx(_components.a, {
            href: "https://react.nodejs.cn/docs/cdn-links.html",
            children: "react CDN bundles"
          }), " and the ", _jsxs(_components.a, {
            href: "https://unpkg.com/react-is/umd/react-is.production.min.js",
            children: [_jsx(_components.code, {
              children: "react-is"
            }), " CDN bundle"]
          }), " to be on the page as well (before the styled-components script.)"]
        }), "\n"]
      })]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
